export const MAX_AUTH_FAILS = 3

export const ROLES = [
    'commander',
    'executive_officer',
    'personnel_officer',
    'combat_officer',
    'intelligence_officer',
    'quartermaster',
    'recruitment_officer',
    'junior_officer',
    'private',
    'recruit',
    'reservist',
]

export const BUTTON_SMALL_TYPES = ['default', 'secondary', 'primary', 'mini', 'miniSecondary']

export const KEY_CODES = Object.freeze({
    ENTER: 13,
    ESCAPE: 27,
    SPACE: 32,
    END: 35,
    HOME: 36,
    ARROW_UP: 38,
    ARROW_DOWN: 40,
    NUM_PLUS: 107,
    NUM_MINUS: 109,
})



// WEBPACK FOOTER //
// ../node_modules/react-wot-bootstrap/lib/constants.js